// @flow
import { getCurrentPathname } from 'app/common/utils/RouterSelectors';

export const isOnSharedZapRoute = (state: Object) => {
  return getCurrentPathname(state).includes('/shared/');
};
